import { FormControl, FormGroup } from '@angular/forms';

export class TagForm extends FormGroup {

    constructor(tagName = '') {
    super({
      tagName: new FormControl(tagName),
    });
  }

  get tagName(): FormControl {
    return this.get('tagName') as FormControl;
  }

  public setTagName(tagName: string): void {
      this.tagName.setValue(tagName);
  }

  public clearTagName(): void {
    return this.get('tagName').setValue('');
  }
}
